// extracted by mini-css-extract-plugin
export default {"app":"App_app__zr1wm","fixedButton":"App_fixedButton__yt8sK","fixedImg":"App_fixedImg__cbbTk","modalContent":"App_modalContent__M1CT4","modalOverlay":"App_modalOverlay__AfBXA"};